import { useQuery, type QueryClient } from '@tanstack/react-query'
import { pluggyStatusApi } from '../../api/endpoints'

export const MENSAGEM_PLUGGY_PADRAO = 'A conexão com o banco está temporariamente indisponível.'

export interface EstadoPluggy {
  /** false só quando o servidor disse que a Pluggy está desligada (API antiga ou falha na consulta = ligada). */
  ativa: boolean
  mensagem: string
  /** A consulta já terminou (com sucesso ou não): antes disso, não dispare chamadas que dependem da Pluggy. */
  pronto: boolean
}

/** Interruptor geral da Pluggy (GET api/pluggy/status). Desligada, os apps escondem "Conectar banco" e mostram o aviso. */
export function usePluggyStatus(): EstadoPluggy {
  const { data, isPending } = useQuery({
    queryKey: ['pluggy-status'],
    queryFn: pluggyStatusApi.get,
    retry: false,
    staleTime: 30_000,
  })
  return { ativa: data?.ativa !== false, mensagem: data?.mensagem?.trim() || MENSAGEM_PLUGGY_PADRAO, pronto: !isPending }
}

/** Resposta 503 das rotas da Pluggy = desligada. O erro já traz a mensagem do servidor (client.ts). */
export function ehPluggyDesligada(erro: unknown): boolean {
  return (erro as { response?: { status?: number } } | null)?.response?.status === 503
}

/** Chame quando uma rota da Pluggy devolver 503: o status é rebuscado e a tela passa a mostrar o aviso. */
export function revalidarSePluggyDesligada(qc: QueryClient, erro: unknown) {
  if (ehPluggyDesligada(erro)) void qc.invalidateQueries({ queryKey: ['pluggy-status'] })
}
